import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LAYER, useSmartClosePopups } from 'js/components/common/PopupManager';

import { VALIDATION_TYPE } from '../constants';
import { closePopupsAction } from 'js/components/common/PopupManager/store/actions';
import { showPinVerificationPopupAction } from 'js/components/popups/PinVerificationPopup';

export const useValidatePin = () => {
    const dispatch = useDispatch();
    const closePopups = useSmartClosePopups();

    return useCallback((pasLoginResponse, options = {}) => new Promise((resolve, reject) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationByPinData) {
            resolve();

            return;
        }

        let isValid = false;
        const { isSSO } = options;

        dispatch(showPinVerificationPopupAction({
            id: VALIDATION_TYPE.PIN_VERIFICATION,
            isSSO,
            onSuccess: () => {
                isValid = true;
                dispatch(closePopupsAction({ popups: [VALIDATION_TYPE.PIN_VERIFICATION] }));
                resolve();
            },
            onClose: () => {
                if (!isValid) {
                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                    reject(pasLoginResponse);
                }
            }
        }));
    }), [
        closePopups, dispatch
    ]);
};
